// «A dónde iba» cuando una pantalla pide sesión: se guarda antes de mandar a /login y
// se lee al entrar (Login.redirectByRole y RoleHome) para volver ahí en vez de caer en el
// home. Vive en sessionStorage (por pestaña) y caduca solo. NUNCA lanza.
const KEY = 'mekafix_returnTo';
const TTL_MS = 10 * 60 * 1000;
// Login y RoleHome pueden leerlo los dos en la misma entrada: se borra con retraso, no al leer.
const BORRADO_TRAS_MS = 3000;

// Solo rutas internas: nada de «//otro-sitio» ni «https://...» (redirección abierta).
export function esDestinoValido(path) {
  return typeof path === 'string' && /^\/(?![/\\])/.test(path) && !/^\/login(\/|\?|$)/.test(path);
}

export function guardarDestino(path) {
  if (!esDestinoValido(path)) return;
  try { sessionStorage.setItem(KEY, JSON.stringify({ path, ts: Date.now() })); } catch (_) { /* sin storage: se cae al home */ }
}

export function leerDestino() {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const { path, ts } = JSON.parse(raw);
    if (!esDestinoValido(path) || !(Date.now() - ts < TTL_MS)) {
      sessionStorage.removeItem(KEY);
      return null;
    }
    return path;
  } catch (_) { return null; }
}

export function limpiarDestino() {
  try { sessionStorage.removeItem(KEY); } catch (_) { /* nada */ }
}

/** Lee el destino y programa su borrado (sin cancelar al desmontar). */
export function tomarDestino() {
  const path = leerDestino();
  if (path) setTimeout(limpiarDestino, BORRADO_TRAS_MS);
  return path;
}
